import React, { useMemo } from 'react';

import FirmSection from 'components/FirmSection';
import PhotoGallery from 'components/PhotoGallery';
import PhotoGalleryControls from 'components/PhotoGallery/components/PhotoGalleryControls';
import FileUploader from 'components/FileUploader';

import { ENDPOINT } from 'constants/endpoints';

import './styles.css';

const FirmAboutEditPhotos = props => {
  const { firmId, data, actions } = props;
  const { items, isPhotosSortable } = data;
  const { onSorting, onChangeSortingMode, onDelete, onUpload } = actions;

  const maxFiles = useMemo(() => 20 - items.length, [items]);

  return (
    <FirmSection title="Photos">
      <PhotoGallery
        firmId={firmId}
        showAll={true}
        isSortable={isPhotosSortable}
        items={items}
        sortFunc={onSorting}
        onDelete={onDelete}
        controls={true}
      />
      {!!items.length && (
        <PhotoGalleryControls
          data={{ isSortable: isPhotosSortable }}
          actions={{ onChangeSortingMode }}
        />
      )}
      {maxFiles > 0 && (
        <FileUploader
          endpoint={`${ENDPOINT.ACTION.FIRM.PHOTO.UPLOAD}?id=${firmId}`}
          onUpload={onUpload}
          maxFiles={maxFiles}
          maxFileSize="20MB"
        />
      )}
    </FirmSection>
  );
};

export default FirmAboutEditPhotos;
